<template>
  <el-popover :visible="isPop" popper-class="screen-order-pop" placement="bottom" width="240">
    <template #reference>
      <i class="iconfont icon-xia order-and-screen" v-show="info.order !== false || info.screen !== false" @click.stop="isPop = !isPop"></i>
    </template>
    <div class="order-screen">
      <template v-if="info.order !== false">
        <template v-if="['organization', 'roule', 'relation-user'].includes(info.type)">
          <div class="order" @click="goOrder('positiveSequence')">
            <i class="iconfont icon-paixu-sheng"></i>
            <span>排序</span>
          </div>
        </template>
        <template v-else>
          <div class="order" @click="goOrder('positiveSequence')">
            <i class="iconfont icon-paixu-sheng"></i>
            <span>正序</span>
          </div>
          <div class="order" @click="goOrder('reverseOrder')">
            <i class="iconfont icon-paixu-jiang"></i>
            <span>倒序</span>
          </div>
        </template>
      </template>
      <div class="screen" @click.stop v-if="info.screen !== false">
        <template v-if="info.type === 'number'">
          <el-input-number style="width:100%" @keydown.enter="goSearch" :controls="false" placeholder="请输入数值搜索" v-model="searchNumber"></el-input-number>
        </template>
        <template v-else-if="info.type === 'date' || info.type === 'timeof'">
          <el-date-picker @change="goSearch" start-placeholder="开始时间" end-placeholder="结束时间" v-model="searchText" style="width: 100%;box-sizing: border-box;" type="daterange" range-separator="至" format="YYYY-MM-DD"  value-format="YYYY-MM-DD"></el-date-picker>
        </template>
        <template v-else>
          <el-input @keydown.enter="goSearch" prefix-icon="el-icon-search" placeholder="请输入关键字搜素" v-model="searchText" />
        </template>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  // 组件名称
  name: 'orderAndScreen',
  // 组件参数 接收来自父组件的数据
  props: {
    info: {
      type: Object,
      default: ()=>({})
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
      isPop: false,
      searchText: '',
      searchNumber: 0,
    }
  },
  mounted() {
    document.addEventListener('click', this.closePop)
  },
  unmounted(){
    document.removeEventListener('click', this.closePop)
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    goSearch() {
      this.$emit('goSearch', { type: 'screen', value: this.info.type === 'number' ? this.searchNumber : this.searchText })
      this.isPop = false
    },
    goOrder(type) {
      this.$emit('goSearch', { type: 'order', value: type })
      this.isPop = false
    },
    closePop() {
      this.isPop = false
    }
  },
}
</script>

<style scoped lang="scss">
.icon-xia {
  font-size: 10px;
  color: #E1E1E1;
  cursor: pointer;
  position: absolute;
  right: 0;
  display: inline-block;
  transition: .3s;
  top: 50%;
  transform: translateY(-50%);
}
.order-screen {
  display: flex;
  flex-direction: column;
  .order {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 4px;
    // transition: .3s;
    // &:hover {
    //   background-color: #4e86ff3e;
    // }
    .icon-bianliang {
      margin-right: 15px;
    } 
  }
  .screen {
    // margin-top: 15px;
  }
}
:deep(.order-screen) {
  .el-input{
    height: 32px;
    line-height: 32px;
    .el-input__inner {
      height: 100%;
      line-height: 32px;
    }
  }
}

:deep(.el-input__prefix) {
  .el-icon-search {
    line-height: 32px;
  }
}

:deep(.el-input__inner) {
  height: 32px;
  line-height: 32px;
}

:deep(.el-date-editor) {
  .el-icon-date {
    line-height: 24px;
  }
  .el-range-separator {
    line-height: 24px;
  }
  .el-range__close-icon {
    line-height: 24px;
  }
}
</style>

<style lang="scss">
.screen-order-pop {
  padding: 5px 10px;
}
</style>
